export default __webpack_public_path__ + "static/media/AG5.f941d0df.jpg";